import { useMemo } from 'react'

import {
  useRestaurantLocationsQuery,
  Restaurant,
  GeneralError
} from 'src/apollo/onlineOrdering'

import { useOOClient } from 'shared/components/common/oo_client_provider/OOClientProvider'
import { useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'
import { SiteRestaurantLocation } from 'shared/js/types'

export const useReservationLocations = ():
  | SiteRestaurantLocation[]
  | undefined => {
  const { locations } = useRestaurant()
  const client = useOOClient()
  const { data } = useRestaurantLocationsQuery({
    variables: {
      restaurantGuids: locations?.map((loc) => loc.externalId) ?? []
    },
    skip: !locations?.length,
    client
  })

  const reservationsEnabledByGuid = useMemo(
    () =>
      data?.restaurants?.reduce(
        (acc: { [key: string]: boolean }, loc: Restaurant | GeneralError) => {
          if (loc.__typename === 'Restaurant') {
            acc[loc.guid] =
              loc.bookingConfig?.onlineReservationsEnabled === true
          }
          return acc
        },
        {}
      ),
    [data]
  )

  return useMemo(
    () =>
      locations && reservationsEnabledByGuid
        ? locations.filter((loc) => reservationsEnabledByGuid[loc.externalId])
        : undefined,
    [locations, reservationsEnabledByGuid]
  )
}

export default useReservationLocations
